import type { SetStateAction } from 'react';
import React from 'react';

export const SongCardContext = React.createContext<{
  /** Is the data being fetched for the card? */
  loading: boolean;
  /** Are we trying to show an album card? */
  album: boolean;
  /** Is the song currently playing? */
  isPlaying: boolean;
  /**
   * Are we trying to render card with multiple editions?
   *
   * @note This will add the stack of cards to the bottom and enable click animation.
   */
  edition: boolean;
  /**
   * Initial state for the card to be expanded or not.
   *
   * @note Only useful for edition cards where we animate on click.
   */
  expanded: boolean | null;
  /**
   * Setter for the expanded state.
   */
  setExpanded: React.Dispatch<SetStateAction<boolean>> | null;
}>({
  loading: false,
  album: false,
  isPlaying: false,
  edition: false,
  expanded: null,
  setExpanded: null,
});

export function useSongCardContext() {
  const context = React.useContext(SongCardContext);
  if (!context) {
    throw new Error(
      `SongCard compound components cannot be rendered outside the SongCard component`,
    );
  }

  return context;
}
